import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { AlertTriangle, Plus, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { usePanel } from "@/context/PanelContext";

export default function IssuesPage() {
  const { openNew } = useOutletContext();
  const { open: openPanel, refreshKey } = usePanel();
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    api.get("/issues").then((r) => setIssues(r.data));
  }, [refreshKey]);

  return (
    <div className="px-6 md:px-10 pt-6 max-w-5xl mx-auto" data-testid="issues-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900">Issues</h1>
          <p className="text-slate-500 mt-1">Blockers and discussions linked to tasks.</p>
        </div>
        <button onClick={openNew} className="tg-btn-primary" data-testid="issues-new">
          <Plus className="h-4 w-4" /> New issue
        </button>
      </div>

      <div className="tg-card divide-y divide-slate-100">
        {issues.length === 0 && (
          <div className="p-8 text-center text-slate-400 text-sm">No issues. Smooth sailing.</div>
        )}
        {issues.map((i) => {
          const resolved = i.status === "resolved";
          return (
            <button
              key={i.id}
              onClick={() => openPanel("issue", i)}
              className="w-full text-left flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition-colors first:rounded-t-2xl last:rounded-b-2xl"
              data-testid={`issue-row-${i.id}`}
            >
              <div className={`tg-stat-icon ${resolved ? "bg-emerald-50" : "bg-orange-50"}`}>
                {resolved ? (
                  <CheckCircle2 className="h-5 w-5 text-emerald-600" />
                ) : (
                  <AlertTriangle className="h-5 w-5 text-orange-600" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className={`font-semibold ${resolved ? "text-slate-400 line-through" : "text-slate-800"} truncate`}>{i.title}</div>
                {i.description && <div className="text-xs text-slate-500 truncate mt-0.5">{i.description}</div>}
              </div>
              <span
                className={`tg-pill ${
                  resolved ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-orange-50 text-orange-700 border-orange-200"
                }`}
              >
                {i.status}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
